let controller1 = new ScrollMagic.Controller();

// secton2
var box2_title=document.getElementsByClassName('ab2text');
var box2_content=document.getElementsByClassName('ab2Items');
let scene2 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.artio_sec2', 
        triggerHook: "onenter",
        duration:0
})
scene2.on("progress", function (event) {
    box2_title[0].classList.add("showup");
    box2_content[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box2_title[0].classList.remove("showup");
        box2_content[0].classList.remove("showup");
    }
})

// secton4
var box4_title=document.getElementsByClassName('abbox4_title');
var box4_content=document.getElementsByClassName('abbox4_text');
let scene4 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.artio_sec4', 
        triggerHook: "onenter",
        duration:0
})
scene4.on("progress", function (event) {
    box4_title[0].classList.add("showup");
    box4_content[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box4_title[0].classList.remove("showup");
        box4_content[0].classList.remove("showup");
    }
})


// secton5
var box5_title=document.getElementsByClassName('abbox5_title');
var box5_content=document.getElementsByClassName('abbox5_text');
let scene5 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.artio_sec5', 
        triggerHook: "onenter",
        duration:0
})
scene5.on("progress", function (event) {
    box5_title[0].classList.add("showup");
    box5_content[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box5_title[0].classList.remove("showup");
        box5_content[0].classList.remove("showup");
    }
})

// secton6
var box6_title=document.getElementsByClassName('abbox6_title');
var box6_content=document.getElementsByClassName('abbox6_text');
let scene6 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.artio_sec6', 
        triggerHook: "onenter",
        duration:0
})
scene6.on("progress", function (event) {
    box6_title[0].classList.add("showup");
    box6_content[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box6_title[0].classList.remove("showup");
        box6_content[0].classList.remove("showup");
    }
})


// secton7
var box7_title=document.getElementsByClassName('abbox7_title');
var box7_content=document.getElementsByClassName('abbox7_text');
let scene7 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.artio_sec7', 
        triggerHook: "onenter",
        duration:0
})
scene7.on("progress", function (event) {
    box7_title[0].classList.add("showup");
    box7_content[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box7_title[0].classList.remove("showup");
        box7_content[0].classList.remove("showup");
    }
})


// secton8
var box8_title=document.getElementsByClassName('abbox8_title');
var box8_content=document.getElementsByClassName('abbox8_text');
let scene8 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.artio_sec8', 
        triggerHook: "onenter",
        duration:0
})
scene8.on("progress", function (event) {
    box8_title[0].classList.add("showup");
    box8_content[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box8_title[0].classList.remove("showup");
        box8_content[0].classList.remove("showup");
    }
})



// secton10 
var box10_title=document.getElementsByClassName('xpb10_titles');
let scene10 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimpro_sec10', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
scene10.on("progress", function (event) {
    box10_title[0].classList.add("showup");
    // box10_title[1].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box10_title[0].classList.remove("showup");
        // box10_title[1].classList.remove("showup");
    }
})

// secton11 
var box11_title=document.getElementsByClassName('xpb11_title');
let scene11 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimpro_sec11', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
scene11.on("progress", function (event) {
    box11_title[0].classList.add("showup");
    box11_title[1].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box11_title[0].classList.remove("showup");
        box11_title[1].classList.remove("showup");
    }
})
controller1.addScene([scene2,scene4,scene5,scene6,scene7,scene8,scene10,scene11]); 

$('.pnr_buy').click(function(){
    window.open('https://store.oxva.com/products/oxva-artio');
})
$('.pnr_cart').click(function(){
    var element = document.querySelector(".artio_sec8");
    element.scrollIntoView({block: "end"});
})
$('.pnr_spec').click(function(){
    var element = document.querySelector(".xlimpro_sec10");
    element.scrollIntoView({block: "end"});
})

//section3
var abbox3 = new Vue({
    el:'#abbox3_active',
    data:function(){
        return{
            flag:0,
            Img:[
                {"title":"GREEN","bagimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Green_b471456c-9288-4427-887d-cf4d9a80c65c.png?v=1683447459",
                "img":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Green_01.png?v=1683447452",
                 "asmlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/GREEN_01_9f1af5c2-d58d-463a-a39d-452f899d40b8.png?v=1683447681",
                "smlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/GREEN_23e23270-37ed-4e79-bf9b-852cae6a8dec.png?v=1683447681"},
                {"title":"PURPLE","bagimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Purple_6961df55-26dd-42af-ae2b-9c0a56a6d323.png?v=1683447459",
                "img":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Purple_01.png?v=1683447452",
                 "asmlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/PURPLE_01_faa6ad95-fdf7-4776-8014-7d836db47e14.png?v=1683447681",
                "smlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/PURPLE_2d73f6c9-0cc5-4afa-8e34-6068d36c3ae6.png?v=1683447681"},
                {"title":"RED","bagimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Red.png?v=1683447459",
                "img":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Red_01.png?v=1683447452",
                 "asmlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/RED_01_c8149211-222c-40c5-829e-982f691f2c5a.png?v=1683447681",
                "smlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/RED_551d9f68-c10c-46ce-8763-3032e4de5cb0.png?v=1683447681"},
                {"title":"GUNMETAL","bagimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Gunmetal.png?v=1683447459",
                "img":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Gunmetal_01.png?v=1683447452",
                 "asmlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/GUNMETAL_01_a79ebc90-cbe4-45d7-b9a8-a375cd9222ed.png?v=1683447681",
                "smlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/GUNMETAL_ce26ac57-3737-4138-8475-e89b47a75258.png?v=1683447681"},
                {"title":"BLACK","bagimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Black_e033e507-7029-44ec-883c-674d62a8676a.png?v=1683447457",
                "img":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Black_01.png?v=1683447452",
                 "asmlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/BLACK_01_6a66d0b0-0222-4e13-b0e6-2669b4d0bfd9.png?v=1683447681",
                "smlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/BLACK_0b103bc7-5dd9-4130-9ee4-58bd1c661f2f.png?v=1683447681"},
            ],
          MImg:[
                {"title":"GREEN","bagimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Green_b471456c-9288-4427-887d-cf4d9a80c65c.png?v=1683447459",
                "img":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/GREEN_8b1479e1-1d67-481e-af6e-febce35b99b4.png?v=1683449183",
                 "asmlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/GREEN_01_9f1af5c2-d58d-463a-a39d-452f899d40b8.png?v=1683447681",
                "smlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/GREEN_23e23270-37ed-4e79-bf9b-852cae6a8dec.png?v=1683447681"},
                {"title":"PURPLE","bagimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Purple_6961df55-26dd-42af-ae2b-9c0a56a6d323.png?v=1683447459",
                "img":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/PURPLE_e6a63ed8-db55-4b5b-ab81-c4c2505ad6be.png?v=1683449183",
                 "asmlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/PURPLE_01_faa6ad95-fdf7-4776-8014-7d836db47e14.png?v=1683447681",
                "smlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/PURPLE_2d73f6c9-0cc5-4afa-8e34-6068d36c3ae6.png?v=1683447681"},
                {"title":"RED","bagimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Red.png?v=1683447459",
                "img":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/RED_ec4ded16-da4c-40d0-82a3-4c4457573434.png?v=1683449183",
                 "asmlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/RED_01_c8149211-222c-40c5-829e-982f691f2c5a.png?v=1683447681",
                "smlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/RED_551d9f68-c10c-46ce-8763-3032e4de5cb0.png?v=1683447681"},
                {"title":"GUNMETAL","bagimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Gunmetal.png?v=1683447459",
                "img":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/BLACK_7c8f3fbd-3b61-4a1c-97f8-ec1d762de614.png?v=1683449183",
                 "asmlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/GUNMETAL_01_a79ebc90-cbe4-45d7-b9a8-a375cd9222ed.png?v=1683447681",
                "smlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/GUNMETAL_ce26ac57-3737-4138-8475-e89b47a75258.png?v=1683447681"},
                {"title":"BLACK","bagimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/Black_e033e507-7029-44ec-883c-674d62a8676a.png?v=1683447457",
                "img":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/GUNMETAL_e68d7d5a-a4f6-44b5-b486-2fc0effa9d12.png?v=1683449183",
                 "asmlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/BLACK_01_6a66d0b0-0222-4e13-b0e6-2669b4d0bfd9.png?v=1683447681",
                "smlimg":"https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/BLACK_0b103bc7-5dd9-4130-9ee4-58bd1c661f2f.png?v=1683447681"},
            ]
        }
    },
    methods:{
        watch:function(index){
            this.flag = index
        }
    }
})

//section11
var xpb11_swiper = new Swiper('.xpb11_swiper', {
	// autoplay: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      disabledClass: 'my-button-disabled',
    },
})

var Mxpb11_swiper = new Swiper('.Mxpb11_swiper', {
	// autoplay: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      disabledClass: 'my-button-disabled',
    },
})